import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import * as Model from '../models/Folder';

interface RequestFunctionAction {
    type: 'REQUEST_FOLDERMANAGE';
}

interface ReceiveFunctionAction {
    type: 'RECEIVE_FOLDERMANAGE';
    model?: Model.ResponseFolder;
    isSuccess: boolean;
}

interface ClearFunctionAction {
    type: 'CLEAR_FOLDERMANAGE';
}

type KnownAction = RequestFunctionAction | ReceiveFunctionAction | ClearFunctionAction

export const actionCreators = {
    requestFunctionFolder: (method: string, body: Model.Folder): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();

        if (appState && appState.folder && method === "GET") {
            fetch(`/v1/folder?sid=` + body.sid + `&companyCode=` + body.company_code + `&nodeCode=` + body.node_code, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
            })
                .then(response => {
                    return response.json() as Promise<Model.ResponseFolder>
                })
                .then(data => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: data, isSuccess: true });
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: false });
                });

            dispatch({ type: 'REQUEST_FOLDERMANAGE' });
        }

        if (appState && appState.folder && method === "ADD") {
            var app_id = "";
            if (body.sid) {
                app_id = body.sid;
            }
            fetch(`/v1/folder/add?app_id=` + app_id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json() as Promise<Model.ResponseFolder>
                })
                .then(data => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: data, isSuccess: true });
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: false });
                });

            dispatch({ type: 'REQUEST_FOLDERMANAGE' });
        }

        if (appState && appState.folder && method === "EDIT") {
            var app_id = "";
            if (body.sid) {
                app_id = body.sid;
            }
            fetch(`/v1/folder/edit?app_id=` + app_id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json() as Promise<Model.ResponseFolder>
                })
                .then(data => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: data, isSuccess: true });
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: false });
                });

            dispatch({ type: 'REQUEST_FOLDERMANAGE' });
        }

        if (appState && appState.folder && method === "RENAME") {
            var app_id = "";
            if (body.sid) {
                app_id = body.sid;
            }
            fetch(`/v1/folder/rename?app_id=` + app_id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json() as Promise<Model.ResponseFolder>
                })
                .then(data => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: data, isSuccess: true });
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: false });
                });

            dispatch({ type: 'REQUEST_FOLDERMANAGE' });
        }

        if (appState && appState.folder && method === "DELETE") {
            var app_id = "";
            if (body.sid) {
                app_id = body.sid;
            }
            fetch(`/v1/folder/delete?app_id=` + app_id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    //return response.json() as Promise<Model.ResponseFolder>
                    return null;
                })
                .then(data => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: true });
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_FOLDERMANAGE', model: undefined, isSuccess: false });
                });

            dispatch({ type: 'REQUEST_FOLDERMANAGE' });
        }

        if (method === "CLEAR") {
            dispatch({ type: 'CLEAR_FOLDERMANAGE' });
        }
    }
};

const unloadedState: Model.FolderState = { isLoading: false, response: undefined, isSuccess: undefined };

export const reducer: Reducer<Model.FolderState> = (state: Model.FolderState | undefined, incomingAction: Action): Model.FolderState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    console.log(action.type)
    switch (action.type) {
        case 'REQUEST_FOLDERMANAGE':
            return {
                isLoading: true,
                response: undefined,
                isSuccess: undefined,
            };
        case 'RECEIVE_FOLDERMANAGE':
            return {
                isLoading: false,
                response: action.model,
                isSuccess: action.isSuccess
            };
        case 'CLEAR_FOLDERMANAGE':
            return {
                isLoading: false,
                response: undefined,
                isSuccess: undefined,
            };

        default: return state;
    }
};